<app-expiration-notice [hasCancelButton]="true" (sendClicked)="send($event)" (cancelClicked)="close()"> </app-expiration-notice>
